"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PostHog = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _get2 = _interopRequireDefault(require("@babel/runtime/helpers/get"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _reactNative = require("react-native");
var _src = require("../../posthog-core/src");
var _storageMemory = require("../../posthog-core/src/storage-memory");
var _legacy = require("./legacy");
var _storage = require("./storage");
var _version = require("./version");
var _nativeDeps = require("./native-deps");
var _wixNavigation = require("./frameworks/wix-navigation");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      (0, _defineProperty2["default"])(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();
  return function _createSuperInternal() {
    var Super = (0, _getPrototypeOf2["default"])(Derived),
      result;
    if (hasNativeReflectConstruct) {
      var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor;
      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }
    return (0, _possibleConstructorReturn2["default"])(this, result);
  };
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
var clientMap = new Map();
var PostHog = function (_PostHogCore) {
  (0, _inherits2["default"])(PostHog, _PostHogCore);
  var _super = _createSuper(PostHog);
  function PostHog(apiKey, options, storage) {
    var _this;
    (0, _classCallCheck2["default"])(this, PostHog);
    var _a;
    _this = _super.call(this, apiKey, options);
    _this._memoryStorage = new _storageMemory.PostHogMemoryStorage();
    _this._appProperties = {};
    _this._persistence = (_a = options === null || options === void 0 ? void 0 : options.persistence) !== null && _a !== void 0 ? _a : 'file';
    _this._appProperties = typeof (options === null || options === void 0 ? void 0 : options.customAppProperties) === 'function' ? options.customAppProperties((0, _nativeDeps.getAppProperties)()) : (options === null || options === void 0 ? void 0 : options.customAppProperties) || (0, _nativeDeps.getAppProperties)();
    _reactNative.AppState.addEventListener('change', function () {
      _this.flush();
    });
    if (_this._persistence === 'file') {
      if (!storage) {
        console.warn('PostHog was initialised without using PostHog.initAsync - this can lead to race condition issues.');
      }
      _this._semiAsyncStorage = storage || new _storage.SemiAsyncStorage((options === null || options === void 0 ? void 0 : options.customAsyncStorage) || (0, _nativeDeps.buildOptimisiticAsyncStorage)());
    }
    var setupAsync = function () {
      var _ref = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee() {
        var _a, _b, _c, _d, _e, legacyValues;
        return _regenerator["default"].wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if ((_a = _this._semiAsyncStorage) === null || _a === void 0 ? void 0 : _a.isPreloaded) {
                  _context.next = 3;
                  break;
                }
                _context.next = 3;
                return (_b = _this._semiAsyncStorage) === null || _b === void 0 ? void 0 : _b.preloadAsync();
              case 3:
                _this.setupBootstrap(options);
                if ((_c = _this._semiAsyncStorage) === null || _c === void 0 ? void 0 : _c.getItem(_src.PostHogPersistedProperty.AnonymousId)) {
                  _context.next = 9;
                  break;
                }
                _context.next = 7;
                return (0, _legacy.getLegacyValues)();
              case 7:
                legacyValues = _context.sent;
                if (legacyValues === null || legacyValues === void 0 ? void 0 : legacyValues.distinctId) {
                  (_d = _this._semiAsyncStorage) === null || _d === void 0 ? void 0 : _d.setItem(_src.PostHogPersistedProperty.DistinctId, legacyValues.distinctId);
                  (_e = _this._semiAsyncStorage) === null || _e === void 0 ? void 0 : _e.setItem(_src.PostHogPersistedProperty.AnonymousId, legacyValues.anonymousId);
                }
              case 9:
                if ((options === null || options === void 0 ? void 0 : options.preloadFeatureFlags) !== false) {
                  _this.reloadFeatureFlags();
                }
                if (!(options === null || options === void 0 ? void 0 : options.captureNativeAppLifecycleEvents)) {
                  _context.next = 17;
                  break;
                }
                if (!(_this._persistence === 'memory')) {
                  _context.next = 15;
                  break;
                }
                console.warn('PostHog was initialised with persistence set to "memory", capturing native app events is not supported.');
                _context.next = 17;
                break;
              case 15:
                _context.next = 17;
                return _this.captureNativeAppLifecycleEvents();
              case 17:
                _context.next = 19;
                return _this.persistAppVersion();
              case 19:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));
      return function setupAsync() {
        return _ref.apply(this, arguments);
      };
    }();
    _this._setupPromise = setupAsync();
    return _this;
  }
  (0, _createClass2["default"])(PostHog, [{
    key: "getPersistedProperty",
    value: function getPersistedProperty(key) {
      return this._semiAsyncStorage ? this._semiAsyncStorage.getItem(key) || undefined : this._memoryStorage.getProperty(key);
    }
  }, {
    key: "setPersistedProperty",
    value: function setPersistedProperty(key, value) {
      return this._semiAsyncStorage ? value !== null ? this._semiAsyncStorage.setItem(key, value) : this._semiAsyncStorage.removeItem(key) : this._memoryStorage.setProperty(key, value);
    }
  }, {
    key: "fetch",
    value: function (_fetch) {
      function fetch(_x, _x2) {
        return _fetch.apply(this, arguments);
      }
      fetch.toString = function () {
        return _fetch.toString();
      };
      return fetch;
    }(function (url, options) {
      return fetch(url, options);
    })
  }, {
    key: "getLibraryId",
    value: function getLibraryId() {
      return 'posthog-react-native';
    }
  }, {
    key: "getLibraryVersion",
    value: function getLibraryVersion() {
      return _version.version;
    }
  }, {
    key: "getCustomUserAgent",
    value: function getCustomUserAgent() {
      return;
    }
  }, {
    key: "getCommonEventProperties",
    value: function getCommonEventProperties() {
      return _objectSpread(_objectSpread(_objectSpread({}, (0, _get2["default"])((0, _getPrototypeOf2["default"])(PostHog.prototype), "getCommonEventProperties", this).call(this)), this._appProperties), {}, {
        $screen_height: _reactNative.Dimensions.get('screen').height,
        $screen_width: _reactNative.Dimensions.get('screen').width
      });
    }
  }, {
    key: "screen",
    value: function screen(name, properties) {
      this.registerForSession({
        $screen_name: name
      });
      return this.capture('$screen', _objectSpread(_objectSpread({}, properties), {}, {
        $screen_name: name
      }));
    }
  }, {
    key: "initReactNativeNavigation",
    value: function initReactNativeNavigation(options) {
      return (0, _wixNavigation.withReactNativeNavigation)(this, options);
    }
  }, {
    key: "captureNativeAppLifecycleEvents",
    value: function () {
      var _captureNativeAppLifecycleEvents = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2() {
        var _this2 = this;
        var _a, prevAppBuild, prevAppVersion, appBuild, appVersion, initialUrl;
        return _regenerator["default"].wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                prevAppBuild = this.getPersistedProperty(_src.PostHogPersistedProperty.InstalledAppBuild);
                prevAppVersion = this.getPersistedProperty(_src.PostHogPersistedProperty.InstalledAppVersion);
                appBuild = this._appProperties.$app_build;
                appVersion = this._appProperties.$app_version;
                if (!appBuild || !appVersion) {
                  console.warn('PostHog could not track installation/update/open, as the build and version were not set. ' + 'This can happen if some dependencies are not installed correctly, or if you have provided' + 'customAppProperties but not included $app_build or $app_version.');
                }
                if (appBuild) {
                  if (!prevAppBuild) {
                    this.capture('Application Installed', {
                      version: appVersion,
                      build: appBuild
                    });
                  } else if (prevAppBuild !== appBuild) {
                    this.capture('Application Updated', {
                      previous_version: prevAppVersion,
                      previous_build: prevAppBuild,
                      version: appVersion,
                      build: appBuild
                    });
                  }
                }
                _context2.next = 8;
                return _reactNative.Linking.getInitialURL();
              case 8:
                _context2.t1 = _a = _context2.sent;
                _context2.t0 = _context2.t1 !== null;
                if (!_context2.t0) {
                  _context2.next = 12;
                  break;
                }
                _context2.t0 = _a !== void 0;
              case 12:
                if (!_context2.t0) {
                  _context2.next = 16;
                  break;
                }
                _context2.t2 = _a;
                _context2.next = 17;
                break;
              case 16:
                _context2.t2 = undefined;
              case 17:
                initialUrl = _context2.t2;
                this.capture('Application Opened', {
                  version: appVersion,
                  build: appBuild,
                  from_background: false,
                  url: initialUrl
                });
                _reactNative.AppState.addEventListener('change', function (state) {
                  if (state === 'active') {
                    _this2.capture('Application Opened', {
                      version: appVersion,
                      build: appBuild,
                      from_background: true
                    });
                  } else if (state === 'background') {
                    _this2.capture('Application Backgrounded');
                  }
                });
              case 20:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));
      function captureNativeAppLifecycleEvents() {
        return _captureNativeAppLifecycleEvents.apply(this, arguments);
      }
      return captureNativeAppLifecycleEvents;
    }()
  }, {
    key: "persistAppVersion",
    value: function () {
      var _persistAppVersion = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3() {
        var appBuild, appVersion;
        return _regenerator["default"].wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                appBuild = this._appProperties.$app_build;
                appVersion = this._appProperties.$app_version;
                this.setPersistedProperty(_src.PostHogPersistedProperty.InstalledAppBuild, appBuild);
                this.setPersistedProperty(_src.PostHogPersistedProperty.InstalledAppVersion, appVersion);
              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));
      function persistAppVersion() {
        return _persistAppVersion.apply(this, arguments);
      }
      return persistAppVersion;
    }()
  }], [{
    key: "_resetClientCache",
    value: function _resetClientCache() {
      clientMap.clear();
    }
  }, {
    key: "initAsync",
    value: function () {
      var _initAsync = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee4(apiKey, options) {
        var _a, posthog, persistence, storage, resolved;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                posthog = clientMap.get(apiKey);
                if (!posthog) {
                  persistence = (_a = options === null || options === void 0 ? void 0 : options.persistence) !== null && _a !== void 0 ? _a : 'file';
                  if (persistence === 'file') {
                    storage = new _storage.SemiAsyncStorage((options === null || options === void 0 ? void 0 : options.customAsyncStorage) || (0, _nativeDeps.buildOptimisiticAsyncStorage)());
                    posthog = storage.preloadAsync().then(function () {
                      return new PostHog(apiKey, options, storage);
                    });
                  } else {
                    posthog = Promise.resolve(new PostHog(apiKey, options));
                  }
                  clientMap.set(apiKey, posthog);
                } else {
                  console.warn('PostHog.initAsync called twice with the same apiKey. The first instance will be used.');
                }
                _context4.next = 4;
                return posthog;
              case 4:
                resolved = _context4.sent;
                _context4.next = 7;
                return resolved._setupPromise;
              case 7:
                return _context4.abrupt("return", resolved);
              case 8:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));
      function initAsync(_x3, _x4) {
        return _initAsync.apply(this, arguments);
      }
      return initAsync;
    }()
  }]);
  return PostHog;
}(_src.PostHogCore);
exports.PostHog = PostHog;